<app-split-pane
  storageKey="split.devops"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.devops.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat
          [suggestions]="devopsSuggestions"
          [context]="devopsContext"
          [orchestratorPageContext]="orchestratorPageContext"
          [conversationId]="activeProjectId()"
          placeholder="Ask about Code Capsules auth, team matching, spaces, and capsules..."
        ></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="devops.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.devops.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="container py-3 devops-shell">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h5 class="mb-1 d-inline-flex align-items-center gap-2">
                Code Capsules DevOps
              </h5>
              <div class="small devops-subtle">Team-first visibility into the selected project's Code Capsules spaces, capsules, and builds.</div>
            </div>
            @if (devopsStore.platform()?.authenticated) {
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-success">
                  <i class="bi bi-check-circle me-1"></i>
                  {{ devopsStore.platform()?.email || 'Signed in' }}
                </span>
                <button class="btn btn-sm btn-outline-secondary" [disabled]="devopsStore.busy()" (click)="logout()">
                  Logout
                </button>
              </div>
            }
          </div>

          @if (devopsStore.error(); as err) {
            <div class="alert alert-danger py-2 px-3 small mb-3">{{ err }}</div>
          }

          @if (!sessionDetermined()) {
            <div class="card mb-3">
              <div class="card-body d-flex align-items-center gap-2">
                <span class="spinner-border spinner-border-sm devops-inline-spinner" role="status" aria-hidden="true"></span>
                <span class="small devops-subtle">Checking Code Capsules session...</span>
              </div>
            </div>
          }

          @if (sessionDetermined() && (!devopsStore.platform()?.authenticated || devopsStore.platform()?.pendingTwoFactor)) {
            <div class="card mb-3">
              <div class="card-header d-flex align-items-center justify-content-between">
                <span class="fw-semibold">Sessions</span>
              </div>
              <div class="card-body">

                <div class="row g-2">
                  <div class="col-md-5">
                    <input class="form-control form-control-sm" [(ngModel)]="loginEmail" type="email" placeholder="Code Capsules email" />
                  </div>
                  <div class="col-md-5">
                    <input class="form-control form-control-sm" [(ngModel)]="loginPassword" type="password" placeholder="Password" />
                  </div>
                  <div class="col-md-2 d-flex gap-2">
                    <button class="btn btn-sm btn-primary w-100" [disabled]="devopsStore.busy() || !loginEmail || !loginPassword" (click)="login()">
                      Login
                    </button>
                    <button class="btn btn-sm btn-outline-secondary w-100" [disabled]="devopsStore.busy()" (click)="logout()">
                      Logout
                    </button>
                  </div>
                </div>
                @if (devopsStore.platform()?.pendingTwoFactor) {
                  <div class="devops-auth-step mt-3">
                    <div class="small fw-semibold mb-2">Authenticator verification</div>
                    <div class="row g-2 align-items-stretch">
                      <div class="col-md-9">
                        <input
                          class="form-control form-control-sm"
                          [(ngModel)]="authenticatorCode"
                          inputmode="numeric"
                          autocomplete="one-time-code"
                          placeholder="Authenticator code"
                        />
                      </div>
                      <div class="col-md-3 d-flex">
                        <button class="btn btn-sm btn-primary w-100 h-100" [disabled]="devopsStore.busy() || !authenticatorCode" (click)="verifyTwoFactor()">
                          Verify 2FA
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (devopsStore.platform()?.authenticated) {
          <div class="card">
            <div class="card-header fw-semibold">Project Deployment Visibility</div>
            <div class="card-body">
              
              @if (devopsStore.selectedCapsuleId() && selectedCapsule) {
                <div class="row g-3 devops-capsule-layout">
                  <div class="col-12 col-xl-7">
                    <ng-container [ngTemplateOutlet]="spaceTabsAndGrid"></ng-container>
                  </div>
                  <div class="col-12 col-xl-5">
                    <ng-container [ngTemplateOutlet]="capsuleDetails"></ng-container>
                  </div>
                </div>
              } @else {
                <ng-container [ngTemplateOutlet]="spaceTabsAndGrid"></ng-container>
              }

            </div>
          </div>
          }
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="devops.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>

<ng-template #spaceTabsAndGrid>
  @if (teamSpaces.length) {
    <ul class="nav nav-tabs devops-space-tabs mb-3">
      @for (space of teamSpaces; track space.id) {
        <li class="nav-item">
          <button
            type="button"
            class="nav-link"
            [class.active]="space.id === devopsStore.selectedSpaceId()"
            (click)="onSpaceChange(space.id)"
          >
            <span class="fw-semibold">{{ space.name }}</span>
            @if (space.environment) {
              <span class="devops-subtle"> · {{ space.environment }}</span>
            }
            <span class="badge bg-secondary ms-2">{{ space.capsuleCount || 0 }}</span>
          </button>
        </li>
      }
    </ul>
  } @else if (devopsStore.loading()) {
    <div class="d-flex align-items-center gap-2 mb-3">
      <span class="spinner-border spinner-border-sm devops-inline-spinner" role="status" aria-hidden="true"></span>
      <span class="small devops-subtle">Loading spaces...</span>
    </div>
  } @else if (devopsStore.platform()?.authenticated) {
    <div class="small devops-subtle mb-3">No spaces found for the matched team.</div>
  }

  @if (selectedSpace) {
    <div class="devops-summary-strip mb-3">
      <div class="small"><span class="devops-subtle">Space:</span> {{ selectedSpace.name }}</div>
      <div class="small"><span class="devops-subtle">Environment:</span> {{ selectedSpace.environment || 'other' }}</div>
      <div class="small"><span class="devops-subtle">Region:</span> {{ selectedSpace.region || '—' }}</div>
      <div class="small"><span class="devops-subtle">Capsules:</span> {{ selectedSpace.capsuleCount || 0 }}</div>
    </div>
  }

  @if (selectedSpace?.matchedRepos?.length) {
    <div class="small devops-subtle mb-3">
      Matched by repo:
      @for (repo of selectedSpace?.matchedRepos ?? []; track repo) {
        <code class="me-2">{{ repo }}</code>
      }
    </div>
  }

  @if (devopsStore.capsules().length) {
    <div class="row g-3 devops-capsule-grid">
      @for (capsule of devopsStore.capsules(); track capsule.id) {
        <div class="col-12 col-md-6 col-lg-4">
          <button
            type="button"
            class="card h-100 devops-capsule-card w-100 text-start"
            [class.is-selected]="capsule.id === devopsStore.selectedCapsuleId()"
            (click)="onCapsuleChange(capsule.id)"
          >
            <div class="card-header d-flex justify-content-between align-items-center">
              <span class="fw-semibold">{{ capsule.name }}</span>
              @if (capsule.status) {
                <span
                  class="badge"
                  [class.bg-success]="isHealthyStatus(capsule.status)"
                  [class.bg-secondary]="!isHealthyStatus(capsule.status)"
                >
                  {{ capsule.status }}
                </span>
              }
            </div>
            <div class="card-body">
              <div class="small"><span class="devops-subtle">Type:</span> {{ capsule.type || '—' }}</div>
              <div class="small"><span class="devops-subtle">Region:</span> {{ capsule.region || '—' }}</div>
              <div class="small"><span class="devops-subtle">Repo:</span> {{ capsule.repo || '—' }}</div>
            </div>
          </button>
        </div>
      }
    </div>
  } @else if (devopsStore.loading() && selectedSpace) {
    <div class="d-flex align-items-center gap-2">
      <span class="spinner-border spinner-border-sm devops-inline-spinner" role="status" aria-hidden="true"></span>
      <span class="small devops-subtle">Loading capsules...</span>
    </div>
  } @else if (selectedSpace) {
    <div class="small devops-subtle">No capsules visible in this space yet.</div>
  }
</ng-template>

<ng-template #capsuleDetails>
  @if (selectedCapsule) {
    <div class="devops-capsule-details">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="m-0">{{ selectedCapsule.name }}</h6>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          aria-label="Close capsule details"
          (click)="closeCapsuleDetails()"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
            @if (selectedCapsule.status) {
              <span
                class="badge"
                [class.bg-success]="isHealthyStatus(selectedCapsule.status)"
                [class.bg-secondary]="!isHealthyStatus(selectedCapsule.status)"
              >
                {{ selectedCapsule.status }}
              </span>
            }
            @if (selectedCapsule.type) {
              <span class="badge bg-secondary">{{ selectedCapsule.type }}</span>
            }
            @if (selectedCapsule.region) {
              <span class="badge bg-secondary">{{ selectedCapsule.region }}</span>
            }
          </div>

          <dl class="row mb-0 small">
            <dt class="col-sm-4 devops-subtle">Name</dt>
            <dd class="col-sm-8">{{ selectedCapsule.name }}</dd>

            <dt class="col-sm-4 devops-subtle">Status</dt>
            <dd class="col-sm-8">{{ selectedCapsule.status || '—' }}</dd>

            <dt class="col-sm-4 devops-subtle">Type</dt>
            <dd class="col-sm-8">{{ selectedCapsule.type || '—' }}</dd>

            <dt class="col-sm-4 devops-subtle">Region</dt>
            <dd class="col-sm-8">{{ selectedCapsule.region || '—' }}</dd>

            <dt class="col-sm-4 devops-subtle">Repo</dt>
            <dd class="col-sm-8">{{ selectedCapsule.repo || '—' }}</dd>

            <dt class="col-sm-4 devops-subtle">URL</dt>
            <dd class="col-sm-8">
              @if (selectedCapsule.url) {
                <a [href]="selectedCapsule.url" target="_blank" rel="noopener noreferrer">
                  {{ selectedCapsule.url }}
                </a>
              } @else {
                —
              }
            </dd>

            @if (selectedSpace) {
              <dt class="col-sm-4 devops-subtle">Space</dt>
              <dd class="col-sm-8">
                {{ selectedSpace.name }}
                @if (selectedSpace.environment) {
                  <span class="devops-subtle"> · {{ selectedSpace.environment }}</span>
                }
              </dd>
            }

            @if (selectedTeam) {
              <dt class="col-sm-4 devops-subtle">Team</dt>
              <dd class="col-sm-8">{{ selectedTeam.name }}</dd>
            }
          </dl>

          @if (selectedSpace?.matchedRepos?.length) {
            <div class="mt-3">
              <div class="small fw-semibold mb-1">Matched repos</div>
              <div class="small devops-subtle">
                @for (repo of selectedSpace?.matchedRepos ?? []; track repo) {
                  <code class="me-2">{{ repo }}</code>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</ng-template>
